<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <span class="breadcrumb-current">Report</span>
  </div>
</div>

<main class="page-content">
  <section class="content-card">
    <h1 class="page-title">{{ pageTitle }}</h1>
    <p class="page-copy">Generate, review, and publish audit reports from this section.</p>
  </section>
</main>
